import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Hook to update page title based on route
export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      '/': 'Penguin Montessori School - Attendance System',
      '/login': 'Login - Penguin Montessori School',
      '/role-selection': 'Select Role - Penguin Montessori School',
      '/dashboard': 'Dashboard - Penguin Montessori School',
      '/attendance': 'Mark Attendance - Penguin Montessori School',
      '/students': 'Student Management - Penguin Montessori School',
      '/reports': 'Attendance Reports - Penguin Montessori School',
      '/notifications': 'Messages - Penguin Montessori School',
      '/settings': 'Settings - Penguin Montessori School',
    };

    const title = titles[location.pathname] || 'Penguin Montessori School - Attendance System';
    document.title = title;
  }, [location]);
};
